import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { customSignupFormRules } from 'helpers/customFormRules';

import { AccountManager, getActiveForms, NotificationManager } from '@atlas/core';
import { onForgotPasswordSubmit, useActiveForm } from '@atlas/react-forms';
import { DefaultPopup, Label } from '@atlas/ui';

import FormWithCaptcha from 'common/Form/FormWithCaptcha/FormWithCaptcha';
import { useHidePopupSignUpDelay } from 'hooks/useHidePopupSignUpDelay';
import { useSetNextShowPopupSignUpDelay } from 'hooks/useSetNextShowPopupSignUpDelay';

const RESPONSE_RESET_TYPE_PHONE = 'PHONE';

const ForgotPassword = () => {
  const {
    location: { pathname },
    push: historyPush,
  } = useHistory();
  const { activeType, submit } = useActiveForm(
    'INIT_PASSWORD_RESET',
    onForgotPasswordSubmit(AccountManager.initPasswordResetWithForm.bind(AccountManager)),
    getActiveForms,
  );
  const submitHandler = useCallback(
    (...props) =>
      submit(...props).then(response => {
        if (response.resetType === RESPONSE_RESET_TYPE_PHONE) {
          historyPush(`${pathname}?cmd=resetPasswordPhone&token=${response.publicToken}`);
          return;
        }

        NotificationManager.notify({
          message: 'reset_password_sended',
          status: 'success',
          type: 'notification',
        });

        historyPush(pathname);
      }),
    [submit, pathname, historyPush],
  );

  const onCloseHandler = useCallback(() => historyPush(pathname), [historyPush, pathname]);

  useHidePopupSignUpDelay();
  useSetNextShowPopupSignUpDelay();

  const formConfig = activeType?.steps[0];
  const realFormConfig = useMemo(() => {
    if (formConfig) {
      return {
        ...formConfig,
        fields: formConfig.fields.map(field => ({
          ...field,
          ...customSignupFormRules(field),
        })),
      };
    }
    return formConfig;
  }, [formConfig]);

  const renderFormFields = activeType && (
    <FormWithCaptcha
      action={submitHandler}
      buttonText="restore_password"
      form={realFormConfig}
      formType={activeType}
    />
  );

  return (
    <DefaultPopup
      className="popup__auth popup__forgot-password"
      headerTitle="restore_password"
      onClose={onCloseHandler}
    >
      <div className="popup__content">
        <Label className="popup__description" message="forgot_password_description" />
        {renderFormFields}
      </div>
    </DefaultPopup>
  );
};

export default ForgotPassword;
